// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bez_a bih_rj bih_rk bih_vh bih_eb bih_vf bih_gu bih_kh"};